import { IAttendance } from "@grassrootly/api/entities";
import { provider } from "../../providers";

export interface UpdateAttendancePayload {
  id: number;
  playerId: number;
  attending: boolean;
  team?: string;
  position?: string | null;
}

export const UpdateAttendance = async (params: UpdateAttendancePayload): Promise<IAttendance> =>
  provider.Request("/games/{id}/player/{playerId}/attendance", params);
